import { Modal } from '@src/Component/Modal/Modal';

/**
 * @typedef {import("@src/Service/TemplateFactory").TemplateFactory} TemplateFactory
 */

/**
 * A simple dynamic modal to warn the user that they may be potentially
 * repurchasing items they already have.
 */
export class RepurchaseWarningModal extends Modal {
    get identifier() {
        return 'repurchase-warning';
    }

    hasRepurchasedProducts() {
        return this._$element.find('.product-list > .product-description').length > 0;
    }

    /**
     * @param {TemplateFactory} templateFactory
     */
    constructor(templateFactory) {
        super();

        this._templateFactory = templateFactory;
    }

    /**
     * @param {string[]} duplicateProducts
     * @param {string} checkoutTarget
     */
    _show(duplicateProducts, checkoutTarget) {
        const $productList = this._$element.find('.product-list');
        $productList.empty();

        duplicateProducts.forEach((description) => {
            const $template = this._templateFactory.render('duplicate-product-description');
            $template.text(description);

            $productList.append($template);
        });

        this._$element.find('.continue-to-checkout').attr('href', checkoutTarget);

        super._show();
    }
}
